import {Node} from '../model'

// Action about nodes data

export interface InitNodesAction {
    type: "INIT_NODES";
    initialState: Array<Node>;
}

export const initNodes = (initialState: Array<Node>): InitNodesAction => ({
    type: "INIT_NODES",
    initialState,
});

export type NodesAction = InitNodesAction;


export interface SetSelectedNodesAction {
    type: "SET_SELECTED_NODES";
    newState: Array<number>;
}

export const setSelectedNodes = (newState: Array<number>): SetSelectedNodesAction => ({
    type: "SET_SELECTED_NODES",
    newState,
});

export interface ClickNodeAction {
    type: "CLICK_NODE";
    node: number;
}

export const clickNode = (node: number): ClickNodeAction => ({
    type: "CLICK_NODE",
    node,
});

export type SelectedNodesAction = SetSelectedNodesAction | ClickNodeAction;